import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import Api from '@app/services/api';
import { downloadBlob } from '@app/services/downloadBlob';

interface IFileParams {
  uid: string;
  kind: 'file' | 'signature';
  fallbackName: string;
}

export const useEpdFileDownload = () =>
  useMutation({
    mutationFn: async ({ uid, kind, fallbackName }: IFileParams) => {
      try {
        const response = await Api.orders.getEpdTitleFile(uid, kind);
        const disposition = String(response.headers['content-disposition'] || '');
        const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
        const plain = disposition.match(/filename="([^"]+)"/i)?.[1];
        const name = encoded ? decodeURIComponent(encoded) : plain || fallbackName;
        downloadBlob(response.data, name);
      } catch (error) {
        const response = (error as AxiosError).response;
        if (response?.data instanceof Blob && response.data.type.includes('json')) {
          response.data = JSON.parse(await response.data.text());
        }
        throw error;
      }
    },
    retry: false,
  });
